import { FlowStorageData } from "./FlowStorageData";
import { FlowExecutionData } from "../../Flow/Engine/FlowExecutionData";
import { ExecutionData } from "../../Common/Data/ExecutionData/ExecutionData";

export class FlowExecutionUtilities {
    static getFlowExecutionDataFromStorage(data: FlowStorageData): FlowExecutionData {
        let ret = new FlowExecutionData("", new ExecutionData());
        ret.setStorageData(data.flowExecutionData);
        return ret;
    }
}
